import { updateViewCountForJobInFirestore } from "../firestoreService";

export async function updateViewCount({ isViewed, jobRefNumber, viewerId }) {
  if (isViewed) return;
  await updateViewCountForJobInFirestore({
    jobRefNumber: jobRefNumber,
    viewerId: viewerId,
  });
}
